import React, { useState } from 'react'
import { Card, Col, Form, Row, Button, ProgressBar, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify';
import { CNPJ, Phone } from 'helpers/Input';
import 'react-toastify/dist/ReactToastify.css';
import masterAgentService from 'services/master-agent-request';
import swal from '../../helpers/swal';
import Swal from 'sweetalert2';
import { history } from 'store';
import { validateDocument } from '../../helpers/document'
import { useCompany } from 'models';

const FinalCustomerStep = ({
  currentStep,
  handleChangeData,
  handleChangeStep,
  handleGetData
}) => {
  if (currentStep !== 1) return null;
  const changeData = (val, prop) => handleChangeData(val, prop, 'customer')

  let fields = [
    { label: "1. CNPJ - Cliente Final", prop: "cnpj", type: "cnpj" },
    { label: "2. Nome da Empresa - Cliente Final", prop: "client_company_name", type: "input" },
    { label: "3. Primeiro Nome - Cliente Final", prop: "client_firstname", type: "input" },
    { label: "4. Sobrenome - Cliente Final", prop: "client_lastname", type: "input" },
    { label: "5. Telefone Móvel - Cliente Final", prop: "client_cellphone", type: "phone" },
    { label: "6. Telefone Fixo - Cliente Final", prop: "client_phone", type: "phone" },
    { label: "7. E-mail - Cliente Final", prop: "client_email", type: "email" },
    { label: "8. Site - Cliente Final", prop: "client_site", type: "input" },
    { label: "9. País - Cliente Final", prop: "client_country", type: "input" },
    { label: "10. Logradouro - Cliente Final", prop: "client_street", type: "input" },
    { label: "11. Número - Cliente Final", prop: "client_number", type: "input" },
    { label: "12. Complemento - Cliente Final", prop: "client_complement", type: "input" },
    { label: "13. CEP - Cliente Final", prop: "client_cep", type: "input" },
    { label: "14. Bairro - Cliente Final", prop: "client_neighborhood", type: "input" },
    { label: "15. Cidade - Cliente Final", prop: "client_city", type: "input" },
    { label: "16. Estado - Cliente Final", prop: "client_state", type: "input" },
  ]

  const validateFields = () => {
    let values_form = handleGetData('customer')
    const showError = message => {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    let hasErrors = 0

    fields.map(field => {
      if (!values_form[field.prop]) {
        showError(field.label)
        hasErrors++
      }

      if (field.prop == "cnpj" && values_form[field.prop] != "") {
        const isValid = validateDocument(field.prop, values_form[field.prop])
        if (!isValid) {
          showError('CNPJ não é válido')
          hasErrors++
        }
      }
    })

    return hasErrors == 0;
  }

  return (<>
    <div className="mb-2">
      <span className="h3">Informações do Cliente Final</span>
    </div>
    {fields.map((field, key) => {
      return (
        <Form.Group key={key}>
          <Form.Label>{field.label} <span className="text-danger">*</span></Form.Label>
          {field.type == "phone" ? (
            <Phone
              cell={field.prop == "cellphone" ? true : false}
              onChange={({ target }) => changeData(target.value, field.prop)}
            />
          ) : (<>
            {field.type == "cnpj" ? (
              <CNPJ onChange={({ target }) => changeData(target.value, field.prop)} />
            ) : (
              <Form.Control
                required
                value={handleGetData('customer', field.prop)}
                type={field.type}
                onChange={({ target }) => changeData(target.value, field.prop)}
              />
            )}
          </>)}
        </Form.Group>
      )
    })}

    <ProgressBar now={(100 / 3) * currentStep} />

    <Button
      className="button-prev mr-3 mt-3"
      variant="primary"
      onClick={e => {
        let valid = validateFields()
        if (valid)
          handleChangeStep(1)
      }}
    >
      Avançar
    </Button>
  </>)
}

const ScansourceAgentStep = ({
  currentStep,
  handleChangeData,
  handleChangeStep,
  handleGetData
}) => {
  if (currentStep !== 2) return null;

  const changeData = (val, prop) => handleChangeData(val, prop, 'agent')

  const fields = [
    { label: "17. Primeiro Nome - Agente", prop: "agent_firstname", type: "input" },
    { label: "18. Segundo Nome - Agente", prop: "agent_lastname", type: "input" },
    { label: "19. Nome da Empresa - Agente", prop: "agent_company_name", type: "input" },
    { label: "20. Telefone Móvel - Agente", prop: "agent_cellphone", type: "phone" },
    { label: "21. Telefone Fixo - Agente", prop: "agent_phone", type: "phone" },
    { label: "22. E-mail - Agente", prop: "agent_email", type: "email" }
  ]

  const validateFields = () => {
    let values_form = handleGetData('agent')
    let empty_fields = 0

    fields.map(field => {
      if (!values_form[field.prop]) {
        toast.error(field.label, {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        empty_fields++
      }
    })

    return empty_fields == 0;
  }

  return (<>
    <div className="mb-2">
      <span className="h3">Informações do Agente ScanSource (indicador da oportunidade)</span>
    </div>
    {fields.map((field, key) => {
      return (
        <Form.Group key={key}>
          <Form.Label>{field.label} <span className="text-danger">*</span></Form.Label>
          {field.type == "phone" ? (
            <Phone
              cell={field.prop == "agent_cellphone" ? true : false}
              onChange={({ target }) => changeData(target.value, field.prop)}
            />
          ) : (
            <Form.Control
              value={handleGetData('agent', field.prop)}
              type={field.type}
              onChange={({ target }) => changeData(target.value, field.prop)}
            />
          )}
        </Form.Group>
      )
    })}

    <ProgressBar now={(100 / 3) * currentStep} />

    <Button
      className="button-prev mr-3 mt-3"
      variant="primary"
      onClick={() => handleChangeStep(-1)}
    >
      Voltar
    </Button>

    <Button
      className="button-next mt-3"
      variant="primary"
      onClick={(e) => {
        let valid = validateFields()
        if (valid)
          handleChangeStep(1)
      }}
    >
      Avançar
    </Button>
  </>)
}

const InfoBusiness = ({
  currentStep,
  handleChangeData,
  handleGetData,
  handleChangeStep,
  setIsLoading,
  isLoading,
  companyId,
}) => {
  if (currentStep !== 3) return null

  const fields = [
    {
      label: "23. Tipo de Espaço Necessário",
      type: "radio",
      prop: "info_space_needed",
      options: [
        "Cage Compartilhado (Menos de 5 Gabinetes)",
        "Cage Privado (Mais de 5 Gabinetes)"
      ]
    },
    { label: "24. Número de Racks", prop: "info_rack_numbers", type: "input" },
    { label: "25. Potência Necessária por Rack", prop: "info_power_needed_rack", type: "input" },
    { label: "26. Segmento do Cliente", prop: "info_client_segment", type: "input" },
    {
      label: "27. Prazo da Decisão",
      type: "radio",
      prop: "info_decision_deadline",
      options: [
        "Menos de Um Mês",
        "1-3 Meses",
        "4-6 Meses",
        "7-12 Meses"
      ]
    },
    {
      label: "28. A solução que você oferece ao cliente final é uma oferta integrada que inclui um Equinix Alliance Partner? Em caso positivo, quais Parceiros?",
      type: "checkbox",
      prop: "info_partners",
      options: [
        "Accenture", "AWS", "Cisco",
        "Dell EMC", "Deloitte", "F5",
        "Google", "HPE", "IBM Softlayer",
        "Microsoft", "NetApp", "NVIDIA - WW Referral",
        "Oracle", "Oracle - Hardware", "SAP", "Tata Consulting Services",
        "VMWare"
      ]
    },
    { label: "29. Requerimentos da Solução / Detalhes", prop: "info_requeriments_solutions", type: "textarea" },
    { label: "30. Especifique o processo de tomada de decisão, sua hierarquia e qual a relação com o tomador de decisão", prop: "info_decision_process", type: "textarea" },
    { label: "31. Eventos convincentes / tomadores de decisões", prop: "info_convincing_events", type: "textarea" }
  ]

  const changeData = (val, prop) => handleChangeData(val, prop, 'info_business')

  const renderField = field => {
    if (field.type == "radio") {
      return (<>
        {field.options.map((option, key) => (
          <Form.Check
            key={key}
            onChange={e => {
              changeData(e.target.value, field.prop)
            }}
            type="radio"
            name={field.prop}
            value={option}
            label={option}
          />
        ))}
      </>)
    } else if (field.type == "input") {
      return (
        <Form.Control
          value={handleGetData('info_business', field.prop)}
          type="input"
          onChange={({ target }) => changeData(target.value, field.prop)}
        />
      )
    } else if (field.type == "checkbox") {
      return (<>
        {field.options.map((option, key) => (
          <Form.Check
            key={key}
            onChange={e => {
              let _aux = handleGetData('info_business', field.prop)
              if (e.target.checked && _aux.indexOf(e.target.value) == -1)
                _aux.push(e.target.value)
              else if (!e.target.checked && _aux.indexOf(e.target.value) > -1)
                _aux.splice(_aux.indexOf(e.target.value), 1)

              changeData(_aux, field.prop)
            }}
            type="checkbox"
            value={option}
            label={option}
          />
        ))}
      </>)
    } else {
      return (
        <Form.Control
          value={handleGetData('info_business', field.prop)}
          onChange={({ target }) => changeData(target.value, field.prop)}
          as="textarea"
          placeholder="Ensira sua resposta"
        />
      )
    }
  }

  const validateFields = () => {
    let values_form = handleGetData('info_business')
    let empty_fields = 0

    fields.map(field => {
      if (!values_form[field.prop] && field.prop !== "partners") {
        toast.error(field.label, {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        empty_fields++
      }
    })

    return empty_fields == 0;
  }

  return (<>
    <div className="mb-2">
      <span className="h3">Informação do Negócio</span>
    </div>
    {fields.map((field, key) => {
      return (
        <Form.Group key={key}>
          <Form.Label>{field.label} <span className="text-danger">*</span></Form.Label>
          {renderField(field)}
        </Form.Group>
      )
    })}

    <ProgressBar now={(100 / 3) * currentStep} />

    <Button
      className="button-prev mr-3 mt-3"
      variant="primary"
      onClick={() => {
        changeData([], 'partners')
        handleChangeStep(-1)
      }}
    >
      Voltar
    </Button>

    <Button
      className="button-next mt-3"
      variant="primary"
      disabled={isLoading}
      onClick={(e) => {
        e.preventDefault()
        let valid = validateFields()
        if (valid) {
          const data = handleGetData()
          const _aux = {
            ...data.customer,
            ...data.agent,
            ...data.info_business
          }
          setIsLoading(true)
          let formData = new FormData()
          formData.append('company_id', companyId)
          formData.append('provider_id', 3)
          formData.append('form_type', 'equinix');
          formData.append('form_data', JSON.stringify(_aux))
          masterAgentService.saveFormOpportunity(formData)
            .then(() => {
              Swal.fire({
                title: 'Sucesso!',
                text: 'Oportunidade enviada!',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false,
                timerProgressBar: true,
                allowOutsideClick: false,
              }).then(result => {
                if (result.isDismissed) history.goBack()
              })
            })
            .catch(e => swal.error(e))
            .finally(() => setIsLoading(false))
        }
      }}
    >
      {isLoading ? (<>
        Enviando <Spinner animation="border" size="sm" />
      </>) : "Enviar"}
    </Button>
  </>)
}

const EquinixForm = () => {
  const { company: currentCompany } = useCompany()

  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({
    customer: {},
    agent: {},
    info_business: {
      info_partners: []
    }
  })

  const prevButton = () => (
    <Button
      className="button-prev mr-3"
      variant="primary"
      onClick={() => handleChangeStep(-1)}
    >
      Voltar
    </Button>
  )

  const nextButton = () => (
    <Button
      type="submit"
      className="button-next"
      variant="primary"
      onClick={(e) => {
        e.preventDefault()
        handleChangeStep(1)
      }}
    >
      Avançar
    </Button>
  )

  const handleChangeStep = nStep => {
    if (nStep + currentStep < 1 || nStep + currentStep > 3) return null

    setCurrentStep(nStep + currentStep)
  }

  const handleGetData = (entity = null, prop = null) => {
    if (prop && entity)
      return data[entity][prop]
    else if (entity && !prop)
      return data[entity]
    else
      return data
  }

  const handleChangeData = (value, prop, entity) => {
    let _aux = data
    _aux[entity][prop] = value
    setData(_aux)
  }

  return (<>
    <Card className="mt-3">
      <Card.Body style={{ background: "#004B8B", color: "#FFFFFF" }}>
        <Card.Title>
          <span style={{ color: "#FFFFFF" }} className="h2">Registro de Oportunidade Equinix</span>
        </Card.Title>
        <Card.Text>Preencha o formulário abaixo para registrar um lead com a Equinix. As informações obrigatórias estão marcadas com *</Card.Text>
        <Card.Text>
        <span className="font-weight-bold">AVISO IMPORTANTE</span>: Todas as informações apresentadas aqui são estritamente confidenciais. Manteremos contato somente com o responsável descrito neste
          formulário para alinhamento da oportunidade, e assim, prosseguiremos o projeto com o Provedor de Serviços Equinix, que atuará em conjunto com o parceiro
          e a ScanSource Master Agent.
        </Card.Text>
      </Card.Body>
      <Card.Body>
        <Row>
          <Col md="12">
            <small><span className="text-danger">*</span> Obrigatória</small><br /><br />
          </Col>
          <Col md="12">
            <Form>
              <FinalCustomerStep
                currentStep={currentStep}
                handleChangeData={handleChangeData}
                handleGetData={handleGetData}
                handleChangeStep={handleChangeStep}
              />

              <ScansourceAgentStep
                currentStep={currentStep}
                handleChangeData={handleChangeData}
                handleGetData={handleGetData}
                handleChangeStep={handleChangeStep}
              />

              <InfoBusiness
                companyId={currentCompany ? currentCompany.id : ""}
                currentStep={currentStep}
                handleChangeData={handleChangeData}
                handleGetData={handleGetData}
                handleChangeStep={handleChangeStep}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
              />
              {/* {prevButton()}
              {nextButton()} */}
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </>)
}

export default EquinixForm